import { User } from '../interfaces/user';
import { Role } from '../interfaces/types';

function checkClientSitePermission(user: User): boolean {
	return !(!user.clients.length || !user.sites.length);
}

function checkUserRole(user: User, roles: Role[], siteId: number): Role | undefined {
	for (const roleId in user.roles) {
		const currentRole = roles.find((role) => role.id === Number(roleId));

		if (!currentRole) {
			break;
		}

		if (user.roles[roleId] === null) {
			return currentRole;
		}

		if (user.roles[roleId].some((role) => role === siteId)) {
			if (user.sites.some((_site) => Number(_site) === siteId)) {
				return currentRole;
			}
		}
	}

	return undefined;
}

function hasPermission(role: Role | undefined, privilege: string[] = []): boolean {
	if (!role) {
		return false;
	}

	if (role.privileges.some((privilege) => privilege.includes('admin'))) {
		return true;
	}

	if (privilege.length === 0) {
		return false;
	}

	const actions = privilege[1] === 'write' ? ['write'] : ['write', 'read'];

	return role.privileges.some((p) => p[0] === privilege[0] && actions.includes(p[1]));
}

const permissions = {
	checkClientSitePermission,
	checkUserRole,
	hasPermission,
};

export default permissions;
